/** Returns the aria-describedby value that points a control at its visible hint or error. */
export const getFieldDescribedBy = ({ id, hint, error }) => {
  if (error) {
    return `${id}-error`;
  }
  if (hint) {
    return `${id}-hint`;
  }
  return undefined;
};
